import React, {useEffect, Suspense} from 'react'
import {useCookies} from 'react-cookie'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import {CircularProgress, Box} from '@mui/material'

// Lazy load revamp portal and map
const RevampedVolunteerPortal = React.lazy(() =>
	import('./pages/RevampedVolunteerPortal')
)
const MapExploration = React.lazy(() => import('./pages/MapExploration'))

// Loading fallback for lazy-loaded revamp portal
function RevampLoading() {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}
		>
			<CircularProgress size={40} sx={{color: '#089eb6'}} />
		</Box>
	)
}

function App() {
	const [, setCookie] = useCookies(['ref_code'])

	// Referral tracking
	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search)
		const ref_code = queryParams.get('ref')
		if (ref_code !== null)
			setCookie('ref_code', ref_code, {path: '/', maxAge: 86400})
		const {origin, pathname} = window.location
		if (queryParams.has('ref')) window.location.replace(origin + pathname)
	}, [setCookie])

	// REVAMP FLOW: Default experience
	return (
		<BrowserRouter>
			<Suspense fallback={<RevampLoading />}>
				<Routes>
					<Route path="/" element={<RevampedVolunteerPortal />} />
					<Route path="/explore" element={<MapExploration />} />
				</Routes>
			</Suspense>
		</BrowserRouter>
	)
}

export default App
